const state = {
  editor: null,
  blockManager: null,
  panels: null,
  commands: null,
  modal: null,
  title: null,
  assetManager: [],
};

const mutations = {
  setEditor(state, editor) {
    state.editor = null;
    state.blockManager = editor.BlockManager;
    state.panels = editor.Panels;
    state.modal = editor.Modal;
    state.commands = editor.Commands;
  },
  setAssetManager(state, assetManager) {
    state.assetManager = assetManager;
  },
};

const actions = {
  setEditor: ({ state, commit }, editor) => commit('setEditor', editor),
  setAssetManager: ({ state, commit }, assetManager) => commit('setAssetManager', assetManager),
};

const getters = {
  getEditor: state => state.editor,
  getModal: state => state.modal,
  getAssetManager: state => state.assetManager,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/grapes-data.js